import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["id", "checked"]
const _hoisted_2 = ["href"]

import Filler from "../../../../shared/Filler.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'checkbox-item',
  props: {
    checked: Boolean,
    href: String,
    name: String,
    id: String,
},
  emits: ["select"],
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass(_ctx.$style['checkbox-item'])
  }, [
    _createElementVNode("input", {
      id: __props.id,
      type: "checkbox",
      class: _normalizeClass(_ctx.$style['checkbox']),
      checked: __props.checked,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('select', !__props.checked)))
    }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_1),
    _createElementVNode("a", {
      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('select', !__props.checked)), ["prevent"])),
      href: __props.href ?? '#',
      class: _normalizeClass(_ctx.$style['link'])
    }, [
      (__props.name == null)
        ? (_openBlock(), _createBlock(Filler, {
            key: 0,
            max: 20
          }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString(__props.name), 1 /* TEXT */)
          ], 64 /* STABLE_FRAGMENT */))
    ], 10 /* CLASS, PROPS */, _hoisted_2)
  ], 2 /* CLASS */))
}
}

})